<template>
  <!-- resubmitPackage Modal -->
  <div
    class="modal fade"
    id="resubmitPackageModal"
    tabindex="-1"
    aria-labelledby="resubmitPackageModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="resubmitPackageModalLabel">
            Resubmit Package Confirmation
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <span v-if="selectedStatus == 'Stalled'">
              Are you sure you want to resubmit the selected {{ selectedPackageType }}?
              The selected {{ selectedPackageType }} along with its related {{ relatedPackageType }} will be resubmitted.
            </span>
            <span v-else>
              This information package cannot be resubmitted.
            </span>
          </div>
        </div>
        <div class="modal-footer">
          <button
            v-if="selectedStatus == 'Stalled'"
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            v-if="selectedStatus == 'Stalled'"
            type="button"
            class="btn btn-danger"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="resubmitPackage"
          >
            Confirm
          </button>
          <button
            v-else
            type="button"
            class="btn btn-secondary"
            style="width: 100%"
            data-bs-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { usePackageStore } from "@/stores/packages";
import { ref, watch } from "vue";

const packageStore = usePackageStore();
const selectedPackages = ref();
const selectedStatus = ref();
const selectedPackageType = ref();
const relatedPackageType = ref();
const props = defineProps({
  selectedId: { type: String },
  selectedStatus: { type: String },
  selectedPackageType: { type: String},
});

watch(
  () => props.selectedId,
  (newId) => (selectedPackages.value = newId)
);

watch(
  () => props.selectedStatus,
  (newStatus) => (selectedStatus.value = newStatus)
);

watch(
  () => props.selectedPackageType,
  (newPackageType) => {
    selectedPackageType.value = newPackageType;
    if(newPackageType == 'AIP') {
      relatedPackageType.value = 'DIP';
    } else if(newPackageType == 'DIP') {
      relatedPackageType.value = 'AIP';
    }
  }
)

const resubmitPackage = async () => {
  await packageStore.resubmitPackage(selectedPackages.value);
};
</script>

<style scoped>
li {
  padding-right: 10px;
  margin: auto;
  display: inline-block;
}
</style>
